// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jn-0";